// Pre-order Cart Clearing for Rebuy Smart Cart 2.0
// This script clears the cart when pre-order products are detected

(function() {
    'use strict';

    // Function to check if cart contains pre-order products
    function checkForPreorderProducts() {
        // code was erroring out when Rebuy wasn't there, added a check
        if(!Rebuy) return
        const cartItems = Rebuy?.Cart?.cart?.items;
        
        if (cartItems && cartItems.length > 0) {
            
            // Check each cart item for pre-order indicators
            const hasPreorderProduct = cartItems.some(item => {
                
                // Check for preorder metafield
                if (item.product && item.product.metafields && 
                    item.product.metafields.preproduct && 
                    item.product.metafields.preproduct.preorder) {
                    return true;
                }
                
                // Check for preorder tag
                if (item.product && item.product.tags && 
                    item.product.tags.includes('preorder')) {
                    return true;
                }
                
                return false;
            });
            
            // If pre-order products are found, clear the cart
            if (hasPreorderProduct) {
                Rebuy.Cart.clearCart();
                
                // Show a notification to the user
                const notification = document.createElement('div');
                notification.style.cssText = `
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    background: #19341a;
                    color: white;
                    padding: 15px 20px;
                    border-radius: 5px;
                    z-index: 999999;
                    font-family: Arial, sans-serif;
                    font-size: 14px;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                    max-width: 300px;
                    word-wrap: break-word;
                `;
                notification.textContent = 'Pre-order products cannot be purchased with other items. Your cart has been cleared.';
                document.body.appendChild(notification);
                
                // Remove notification after 5 seconds
                setTimeout(() => {
                    if (notification.parentNode) {
                        notification.parentNode.removeChild(notification);
                    }
                }, 3000);
            }
        }
    }

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializePreorderCartClear);
    } else {
        initializePreorderCartClear();
    }

    function initializePreorderCartClear() {
        // Event listeners for comprehensive coverage
        document.addEventListener('rebuy:smartcart.show', (event) => {
            setTimeout(() => {
                checkForPreorderProducts();
            }, 100);
        });

        document.addEventListener('rebuy:cart.change', (event) => {
            setTimeout(() => {
                checkForPreorderProducts();
            }, 100);
        });

        document.addEventListener('rebuy:cart.add', (event) => {
            setTimeout(() => {
                checkForPreorderProducts();
            }, 100);
        });

        document.addEventListener('rebuy.productsChange', (event) => {
            setTimeout(() => {
                checkForPreorderProducts();
            }, 100);
        });

        // Check for pre-order products on Rebuy initialization
        document.addEventListener('rebuy:init', (event) => {
            setTimeout(() => {
                checkForPreorderProducts();
            }, 100);
        });

        // Also check when the page loads (in case Rebuy is already initialized)
        setTimeout(() => {
            checkForPreorderProducts();
        }, 500);
    }

})(); 